export default {
  name: 'NewsTags',
  data: function data() {
    return {
      // 新闻标签数据（视频路径指向 public/videos 下的本地文件）
      newsTags: [{
        id: 12,
        title: "什么是献血间隔期",
        cover: "/images/blood-donation12.jpg",
        videoUrl: "/images/blood-donation12.mp4"
      }, {
        id: 11,
        title: "献血需要多久恢复",
        cover: "/images/blood-donation11.png",
        videoUrl: "/images/blood-donation11.mp4"
      }, {
        id: 10,
        title: "献血对身体有哪些影响",
        cover: "/images/blood-donation10.jpg",
        videoUrl: "/images/blood-donation10.mp4"
      }, {
        id: 9,
        title: "互助献血为何被叫停",
        cover: "/images/blood-donation9.jpg",
        videoUrl: "/images/blood-donation9.mp4"
      }, {
        id: 8,
        title: "为什么难以落实优先用血",
        cover: "/images/blood-donation8.jpg",
        videoUrl: "/images/blood-donation8.mp4"
      }, {
        id: 7,
        title: "为什么献血无偿用血收费",
        cover: "/images/blood-donation7.jpg",
        videoUrl: "/images/blood-donation7.mp4"
      }, {
        id: 6,
        title: "为什么全世界都在推行无偿献血",
        cover: "/images/blood-donation6.jpg",
        videoUrl: "/images/blood-donation6.mp4"
      }, {
        id: 5,
        title: "6．14献血者日",
        cover: "/images/blood-donation5.png",
        videoUrl: "/images/blood-donation5.mp4"
      }, {
        id: 4,
        title: "血型的秘密",
        cover: "/images/blood-donation4.png",
        videoUrl: "/images/blood-donation4.mp4"
      }, {
        id: 1,
        title: "输血的前世今生（第一集）",
        // desc: "带你了解无偿献血的重要意义与科学知识",
        cover: "/images/blood-donation1.jpg",
        // 封面图用在线示例图
        videoUrl: "/images/blood-donation1.mp4" // 本地视频路径（public 目录下）

      }, {
        id: 2,
        title: "输血的前世今生（第二集）",
        // desc: "血液如何保障安全？检测流程全解析",
        cover: "/images/blood-donation2.jpg",
        videoUrl: "/images/blood-donation2.mp4"
      }, {
        id: 3,
        title: "输血的前世今生（第三集）",
        cover: "/images/blood-donation3.jpg",
        videoUrl: "/images/blood-donation3.mp4"
      }]
    };
  }
};